export const ASKFRANK_HOSTS = ['askfrank.fyi', 'www.askfrank.fyi'];

export const currentHost = () => (
    typeof window === 'undefined' ? '' : String(window.location.hostname || '').toLowerCase()
);

export const isAskFrankHost = (host = currentHost()) => ASKFRANK_HOSTS.includes(host);

export const basePath = () => (isAskFrankHost() ? '' : '/askfrank');

export const ORIGINS_HOME = 'https://franklyorigins.net/';

export const originsHomeUrl = () => (isAskFrankHost() ? ORIGINS_HOME : '/');

export const deskPath = () => (isAskFrankHost() ? '/' : '/askfrank');

export const homePath = () => (isAskFrankHost() ? '/home' : '/askfrank/home');

export const resultsPath = (query) => {
    const cleaned = String(query || '').trim();
    if (!cleaned) return deskPath();

    return isAskFrankHost()
        ? `/results=${encodeURIComponent(cleaned)}`
        : `/askfrank/results?q=${encodeURIComponent(cleaned)}`;
};

export const viewPath = () => `${basePath()}/view`;

export const docPath = (kind, slug) => `${basePath()}/doc/${kind}/${slug}`;

export const readQuery = (location, searchParams) => {
    const fromSearch = searchParams?.get('q');
    if (fromSearch) return fromSearch;

    const match = String(location?.pathname || '').match(/^\/results=(.*)$/);
    if (!match) return '';

    try {
        return decodeURIComponent(match[1]);
    } catch {
        return match[1];
    }
};

export const isResultsPath = (location) => {
    const path = String(location?.pathname || '');
    return /^\/results=/.test(path) || path.startsWith('/askfrank/results');
};

export const isViewerPath = (location) => {
    const path = String(location?.pathname || '');
    return path.startsWith('/askfrank/view')
        || path.startsWith('/franklynet/view')
        || (isAskFrankHost() && path.startsWith('/view'));
};

export const siteName = () => 'AskFrank';

